/*
 * File: Localizer.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Date-fns localizer for react-big-calendar
 */

import { DateLocalizer } from "react-big-calendar";
import { format as dateFnsFormat, isSameMonth } from "date-fns";

const dateRangeFormat = ({ start, end }) => {
  return (
    dateFnsFormat(start, "MM/dd/yyyy") +
    " - " +
    dateFnsFormat(end, "MM/dd/yyyy")
  );
};

const timeRangeFormat = ({ start, end }) => {
  return dateFnsFormat(start, "h:mm a") + " - " + dateFnsFormat(end, "h:mm a"); // 8:30 am
};

const timeRangeStartFormat = ({ start }) => {
  return dateFnsFormat(start, "h:mm a"); // 8:30 am
};

const timeRangeEndFormat = ({ end }) => {
  return dateFnsFormat(end, "h:mm a"); // 8:30 am
};

const weekRangeFormat = ({ start, end }) => {
  const startFormat = "MMMM dd"; // January 01..31
  const endFormat = isSameMonth(start, end)
    ? "dd" // 01..31
    : startFormat;
  return (
    dateFnsFormat(start, startFormat) + " - " + dateFnsFormat(end, endFormat)
  );
};

export const formats = {
  dateFormat: "d", // 01..31
  dayFormat: "dd E", // 01..31 Sun
  weekdayFormat: "E", // Sun

  selectRangeFormat: timeRangeFormat,
  eventTimeRangeFormat: timeRangeFormat,
  eventTimeRangeStartFormat: timeRangeStartFormat,
  eventTimeRangeEndFormat: timeRangeEndFormat,

  timeGutterFormat: "h:mm a", // 4:04 am

  monthHeaderFormat: "MMMM yyyy", // September 2019
  dayHeaderFormat: "EEEE MMM dd", // Monday Sep 01
  dayRangeHeaderFormat: weekRangeFormat,
  agendaHeaderFormat: dateRangeFormat,

  agendaDateFormat: "E MMM dd", // Mon Sep 01
  agendaTimeFormat: "h:mm a", // 4:04 am
  agendaTimeRangeFormat: timeRangeFormat
};

export default new DateLocalizer({
  formats,

  firstOfWeek() {
    return 0;
  },

  format(value, format) {
    return dateFnsFormat(value, format);
  }
});
